import clsx from 'clsx';

interface ITabsProps {
  className?: string;
  children?: React.ReactNode;
}

export const Tabs = (props: ITabsProps) => {
  return <ul className={clsx('flex flex-wrap list-none', props.className)}>{props.children}</ul>;
};
